import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract,NftPurchaseContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const SaleStatusNft = () => {

  const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.nftPurchase;
  const contract = NftPurchaseContract(tokenAddress, web3);


  const saleStatusNft = useCallback(
    async () => {
 
      try {
        const buy = await contract.methods.buyEnable().call()
        return buy;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return { saleStatusNft: saleStatusNft };
};
export default SaleStatusNft;